module.exports = __webpack_public_path__ + "static/suggestion_obj03@2x-50ab97e48e4b5c5438f9effe0946d2c5.png";